import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) {
        nav("/login");
        return;
      }
      try {
        const r = await api.post("/auth/google/session", { session_id: m[1] });
        setUser(r.data.user);
        toast.success(`Welcome, ${r.data.user.name}`);
        // remove hash
        window.history.replaceState(null, "", window.location.pathname);
        nav("/dashboard", { state: { user: r.data.user } });
      } catch (err) {
        toast.error("Sign-in failed");
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8]">
      <div className="text-center">
        <div className="font-serif text-4xl mb-4">Forge<span className="text-[#E63946]">.</span></div>
        <div className="overline">Signing you in…</div>
      </div>
    </div>
  );
}
